import { Box } from '@mantine/core';
import { integrationList } from '@repo/common/constants/integration/integrations';
import type { IIntegration } from '../../../api';
import { UserLevelCredentialsManager } from '../../Integration/IntegrationPage/TabPanels/PreferencesPanel/UserLevelCredentialsManager';
import { useModals } from '../../ModalManager/hooks';

interface UserLevelCredentialsModalProps {
	integration: IIntegration;
	onCredentialsSaved?: () => void;
}

export function UserLevelCredentialsModal({
	integration,
	onCredentialsSaved,
}: UserLevelCredentialsModalProps) {
	const { closeAll } = useModals();

	const spec = integrationList.find((spec) => spec.type === integration.type);

	if (!spec) {
		return <Box>Integration specification not found</Box>;
	}

	const handleCredentialsSaved = () => {
		onCredentialsSaved?.();
		closeAll();
	};

	return (
		<Box>
			<UserLevelCredentialsManager
				integration={integration}
				spec={spec}
				onCredentialsSaved={handleCredentialsSaved}
			/>
		</Box>
	);
}
